The response from the `toggleVerifyWithSeekPass` mutation.
